import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { PuffLoader } from "react-spinners";

import { Box, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import constants from "../../assets/constants";
import * as OnboardingSessionActions from "../../state/redux/onboardingSession";
import Portal from "../ui/portal";
import PortalGridContent from "../ui/portalGridContent";
import OmniTOS from "../widgets/omniTOS";
import UserOnboardAssessment from "../widgets/userOnboardAssessment";
import UserOnboarding from "../widgets/userOnboarding";

const onboardingKeySearchParam = "inviteKey";
const onboardingAssessmentType = "assessmentType";

const OnboardingPortal = props => {
  const { organizationODM, setOnboardingAssessmentTypeRequest } = props;

  const theme = useTheme();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const inviteKey = urlParams.get(onboardingKeySearchParam);

    props.setInviteKeyRequest(inviteKey);

    const assessmentType = urlParams.get(onboardingAssessmentType);
    if (assessmentType) {
      setOnboardingAssessmentTypeRequest(assessmentType);
    }

    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const [backgroundImage, setBackgroundImage] = useState(`linear-gradient(#c5c0c2)`);

  const [organizationType, setOrganizationType] = useState(null);

  useEffect(() => {
    if (organizationODM != null) {
      if (organizationODM.omniData.onboardingBackground) {
        setBackgroundImage(`url(${organizationODM.omniData.onboardingBackground})`);
      }
      setOrganizationType(organizationODM.omniData.organizationType);
    }
  }, [organizationODM]);

  return (
    <Portal
      displayHeader={false}
      sx={{
        backgroundImage: backgroundImage,
        backgroundSize: "cover",
      }}
    >
      <PortalGridContent
        hasPortalAppBar={false}
        sx={{ minHeight: "100vh", alignItems: "center", margin: "auto" }}
      >
        {organizationType != null &&
          organizationType !== constants.organizationTypeEnums.botpressTesting && (
            <Grid
              item
              xs={12}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <UserOnboardAssessment />
              <OmniTOS />
            </Grid>
          )}
        {organizationType === constants.organizationTypeEnums.botpressTesting && (
          <Grid
            item
            xs={12}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              sx: { maxWidth: "600px" },
            }}
          >
            <UserOnboarding />
            <OmniTOS />
          </Grid>
        )}
        {organizationType === null && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              alignItems: "center",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <PuffLoader
              color={theme.palette.background.contrastText}
              loading={organizationType == null}
              size={200}
            />
            <Typography sx={{ marginTop: "20px" }} variant="h6">
              Loading...
            </Typography>
          </Box>
        )}
      </PortalGridContent>
    </Portal>
  );
};

const mapStateToProps = state => ({
  organizationODM: state.onboardingSession.organizationODM,
});

const mapDispatchToProps = {
  setInviteKeyRequest: OnboardingSessionActions.setInviteKeyRequest,
  setOnboardingAssessmentTypeRequest: OnboardingSessionActions.setOnboardingAssessmentTypeRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OnboardingPortal));
